<template>
  <div class="ohyes-card" data-aos="zoom-in-left">
    <div class="glossy-overlay"></div>
    <div class="ohyes-header" data-aos="fade-down">
      <div class="website-url">
        <a
          style="text-decoration: none; color: #f46523"
          href="https://ohyesworld.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.ohyesworld.com
        </a>
      </div>

      <div class="ohyes-logo">
        <span class="logo-text">oh yes</span>
      </div>
    </div>
    <div class="main-content" data-aos="fade-up" data-aos-delay="200">
      <div class="shield-icon">
        <v-img :src="require('@/assets/icons/protection.png')" alt="Protection" contain />
      </div>
      <h3 class="main-title">Provide Comprehensive Solutions for Your Home Needs</h3>
    </div>
    <div class="house-image-container" data-aos="zoom-in-up" data-aos-delay="400">
      <v-img
        :src="require('@/assets/images/home.png')"
        alt="3D Home Protection"
        contain
        class="house-image"
      />
    </div>
    <div class="app-download-section" data-aos="fade-up" data-aos-delay="600">
      <h4 class="download-title">Get Your Oh Yes App</h4>
      <div class="app-buttons">
        <a
          href="https://play.google.com/store/apps/details?id=com.ohyes.app&pcampaignid=web_share"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div class="app-button google-play" data-aos="flip-left">
            <v-icon left color="white">mdi-google-play</v-icon>
            <div class="button-text">
              <div class="store-name">Google Play</div>
            </div>
          </div>
        </a>

        <a
          href="https://apps.apple.com/in/app/oh-yes-home-solution/id6471665769"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div class="app-button app-store" data-aos="flip-right" data-aos-delay="200">
            <v-icon left color="white">mdi-apple</v-icon>
            <div class="button-text">
              <div class="store-name">App Store</div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default { name: 'OhYesCard' };
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200..1000;1,6..12,200..1000&display=swap');

.ohyes-card {
  font-family: 'Nunito Sans', sans-serif;

  background: linear-gradient(145deg, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.85));
  backdrop-filter: blur(20px);
  border-radius: 16px;
  padding: 18px;
  max-width: 380px;
  width: 100%;
  margin: 0 auto;
  box-shadow:
    0 15px 35px rgba(0, 0, 0, 0.12),
    0 5px 15px rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;
  transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.glossy-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 40%;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.4) 0%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0.1) 100%
  );
  pointer-events: none;
  z-index: 1;
}

.ohyes-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
  flex-wrap: wrap;
  gap: 8px;
  position: relative;
  z-index: 2;
}

.website-url {
  color: #ff9800;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  background: linear-gradient(135deg, rgba(255, 243, 224, 0.9), rgba(255, 224, 178, 0.8));
  border-radius: 16px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 152, 0, 0.2);
}

.ohyes-logo .logo-text {
  color: #ff9800;
  font-size: 24px;
  font-weight: 900;
  text-transform: lowercase;
}

.main-content {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
  flex-wrap: wrap;
  text-align: left;
  position: relative;
  z-index: 2;
}

.shield-icon .v-image {
  max-width: 40px;
  max-height: 40px;
}

.main-title {
  flex: 1;
  font-size: clamp(16px, 2vw, 20px);
  line-height: 1.3;
  font-weight: 700;
  background: linear-gradient(135deg, #333, #666);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.house-image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 8px 0;
  position: relative;
  z-index: 2;
}

.house-image {
  max-width: 75%;
  height: auto;
  filter: drop-shadow(0 8px 20px rgba(0, 0, 0, 0.15));
  transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1);
}

.house-image:hover {
  transform: scale(1.02);
}

.app-download-section {
  background: linear-gradient(135deg, rgba(248, 249, 250, 0.9), rgba(255, 255, 255, 0.8));
  backdrop-filter: blur(15px);
  border-radius: 12px;
  padding: 12px;
  text-align: center;
  margin-top: 15px;
  position: relative;
  z-index: 2;
  border: 1px solid rgba(255, 255, 255, 0.4);
}

.download-title {
  font-size: clamp(16px, 1.8vw, 19px);
  font-weight: 700;
  background: linear-gradient(135deg, #ff9800, #f46523);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 12px;
}

.app-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-wrap: nowrap;
}

.app-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(51, 51, 51, 0.95), rgba(85, 85, 85, 0.9));
  backdrop-filter: blur(10px);
  color: white;
  padding: 8px 16px;
  border-radius: 10px;
  cursor: pointer;
  width: 150px;
  height: 50px;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow:
    0 4px 15px rgba(0, 0, 0, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
}

.app-button:hover {
  transform: translateY(-2px);
  background: linear-gradient(135deg, rgba(51, 51, 51, 1), rgba(85, 85, 85, 0.95));
  box-shadow:
    0 6px 20px rgba(0, 0, 0, 0.25),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.button-text {
  margin-left: 8px;
  text-align: left;
}

.store-name {
  font-size: 13px;
  font-weight: bold;
}

.app-buttons a {
  text-decoration: none; /* removes underline */
  color: inherit; /* keeps the button’s existing text color */
  display: inline-block; /* ensures the entire div is clickable */
}
</style>
